import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css'; // Any global styles or resets
import reportWebVitals from './reportWebVitals'; // Import reportWebVitals

const container = document.getElementById('root');
const root = createRoot(container); // Create a root for React 18

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Measuring performance in your app
reportWebVitals();
